Vue.config.devtools = true;
import Vue from "vue";
import Vuex from "vuex";
import VueCroppie from "vue-croppie";
import moment from "moment";
import "./services/events";
import momentDurationFormatSetup from "moment-duration-format";
import PortalVue from "portal-vue";
import VueMq from "vue-mq";
import VeeValidate from "vee-validate";
import Vuency from "vuency";
import VueClipboard from "vue-clipboard2";
import VueLazy from "vue-lazyload";
import api from "@/services/api";
import domainConfig from "../../../domain-config.json";
import FlashMessage from "@/srui/components/FlashMessage/FlashMessage";
import GmapVue from "gmap-vue";
import { forEach, get, set } from "lodash";

import {
  convertAllElements,
  convertElement,
  destroyElement,
  getComponentByName,
} from "./vue-launcher.js";

const EventBeacon = () => import("@/components/EventBeacon/EventBeacon");
const Pendo = () => import("@/components/Pendo");
const DevTools = () => import("@/components/DevTools/DevTools");
const AthleteSearch = () => import("@/components/AthleteSearch/Search");
const AthleteSearchMobileNavIcon = () =>
  import("@/components/AthleteSearch/MobileNavIcon");

let elementConfig = {
  EventBeacon,
  AthleteSearch,
  AthleteSearchMobileNavIcon,
  Pendo,
  DevTools,
};

import CopyContent from "@/components/CopyContentLazy";
import DomainComponent from "@/components/DomainComponentLazy";

import formatDate from "@/filters/formatDate";
import ago from "@/filters/ago";
import commaAnd from "@/filters/commaAnd";
import formatHeight from "@/filters/formatHeight";

// Directives
import show from "@/directives/show";
import preventBodyScroll from "@/directives/preventBodyScroll";

momentDurationFormatSetup(moment);

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(PortalVue);
Vue.use(VeeValidate, { inject: false, classes: true });
Vue.use(VueCroppie);
Vue.use(Vuency);
Vue.use(VueClipboard);
Vue.use(VueLazy, {
  observer: true,
  observerOptions: {
    rootMargin: "0px",
    threshold: 0.1,
  },
});
Vue.use(FlashMessage);
Vue.use(GmapVue, {
  installComponents: false,
  dynamicLoad: true,
});

const breakpoints = {
  mobile: 768,
  desktop: Infinity,
  "2xs": 440,
  xs: 640,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1281,
};

Vue.use(VueMq, { breakpoints });

Vue.mixin({
  methods: {
    $media(min) {
      const goodPoints = Object.keys(breakpoints).filter(
        (name) => breakpoints[name] >= breakpoints[min]
      );
      return goodPoints.includes(this.$mq);
    },
    $breakpoint(breakpoint) {
      return breakpoints[breakpoint];
    },
  },
});

Vue.directive("prevent-body-scroll", preventBodyScroll);
Vue.directive("show", show);

Vue.filter("formatHeight", formatHeight);
Vue.filter("formatDate", formatDate);
Vue.filter("ago", ago);
Vue.filter("commaAnd", commaAnd);

const domainComponents = require(`./domain-component-registrar`).default;
const currentDomain = get(api.clientData("domain"), "slug", "sportsrecruits");

forEach(domainComponents, (components, domain) => {
  if (String(domain).toLowerCase() === String(currentDomain).toLowerCase()) {
    set(elementConfig, `domains.${domain}`, {});

    forEach(components, (component, name) => {
      set(elementConfig, `domains.${domain}.${name}`, component);
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  convertAllElements(elementConfig);
});

Vue.component("CopyContent", CopyContent);
Vue.component("DomainComponent", DomainComponent);

Vue.prototype["$domain"] = {
  component(name) {
    return getComponentByName(name, elementConfig);
  },
  config(key, defaultVal) {
    return _.get(domainConfig, `${currentDomain}.${key}`, defaultVal);
  },
  current() {
    return api.clientData("domain");
  },
};

Vue.prototype["$window"] = window;

Vue.prototype["$copyContent"] = (path, props) => {
  props = props ? props : {};

  let Component = Vue.extend(CopyContent);
  let instance = new Component({
    propsData: {
      path: path,
      cData: props,
    },
  });

  instance.$mount();

  return instance.$el.innerHTML;
};

window.mountVue = (element, config = {}) =>
  convertElement(element, elementConfig, config);
window.dismountVue = (element) => destroyElement(element);
